/**
 * Strip PII before anything reaches logs, analytics, or Sentry (ARCHITECTURE §7).
 * Used by BOTH the logger and the Sentry beforeSend scrubber so there is one rule.
 */
const PII_KEY = /(email|phone|password|secret|token|authorization|cookie|ssn|card|iban|dob)/i;
const REDACTED = '[redacted]';

export function redact<T>(value: T, seen = new WeakSet<object>()): T {
  if (value === null || typeof value !== 'object') return value;
  if (seen.has(value)) return value;
  seen.add(value);

  if (Array.isArray(value)) {
    return value.map((item: unknown) => redact(item, seen)) as T;
  }

  const out: Record<string, unknown> = {};
  for (const [key, val] of Object.entries(value as Record<string, unknown>)) {
    out[key] = PII_KEY.test(key) ? REDACTED : redact(val, seen);
  }
  return out as T;
}
